import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult } from '@tanstack/react-query'
import { usePortalMutation } from 'src/Libs/api'
import { submitNda as submitNdaRequest } from '../nda.api'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'

interface UseNdaSubmittingParams {
  companyId: number
  onSuccess?: () => void
  onError?: () => void
}

type UseNdaSubmittingParamsReturnType = (params: UseNdaSubmittingParams) => UseMutationResult<string | null, unknown, void>

/**
 * Custom hook to submit NDAs
 */
const useNdaSubmitting: UseNdaSubmittingParamsReturnType = ({ companyId, onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResult()
  const { pageActions } = useNewRelic()

  const logEvent = (value: string): void => {
    pageActions.logEvent({ logValue: value })
  }

  const submitNda = usePortalMutation({
    mutationFn: () => submitNdaRequest(companyId, authFetch, logEvent),
    onSuccess: () => onSuccess?.(),
    onError: () => onError?.(),
  })

  return submitNda
}

export default useNdaSubmitting
